<template>
  <div class="">

      <div v-if="error" class="rounded-md bg-red-100 p-4 mb-4">
          <div class="flex">
              <div class="flex-shrink-0">
                  <IconXCircleSolid class="text-red-400" size="5"></IconXCircleSolid>
              </div>
              <div class="ml-3">
                  <h3 class="text-sm font-medium text-red-800">
                      {{error}}
                  </h3>
              </div>
          </div>
      </div>
      
      
      
      <div class="mb-2">{{ _("Please enter your address below") }}</div>


      <template v-if="validating">
          <div class="py-2 px-4 bg-white rounded-lg mb-2">
              {{ address }}
          </div>
          <div>

              <gmap-map
                  ref="mapRef"
                  :center="{lat:lat, lng:lng}"
                  :options="{mapTypeControl: false, streetViewControl: false}"
                  :zoom="17"
                  map-type-id="terrain"
                  style="width: 100%; height: 300px"
              >
                  <gmap-marker :position="{lat:lat, lng:lng}"></gmap-marker>
              </gmap-map>
              
          </div>

          <div class="w-full">
              <div @click="newAddress" class="block my-2 bg-indigo-600 rounded-lg px-4 py-2 uppercase font-medium text-sm text-white text-center mr-2">
                  {{ _("Save Address") }}
              </div>


              <div @click="validating=false" class="bg-gray-300 rounded-lg px-4 py-2 uppercase font-medium text-sm text-gray-900 text-center">
                  {{ _("Change") }}
              </div>
          </div>
          
      </template>
      <template v-else>
        
          <div class="mb-4">

            <gmap-autocomplete class="px-4 py-4 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                               :placeholder="_('Enter your address here')" 
                               @place_changed="getAddressData">
            </gmap-autocomplete>
            
<!--              <vue-google-autocomplete-->
<!--                  id="map"-->
<!--                  classname="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"-->
<!--                  :placeholder="_('Enter your address here')"-->
<!--                  v-on:placechanged="getAddressData"-->
<!--                  country="ca"-->
<!--              >-->
<!--              </vue-google-autocomplete>-->
          </div>
          <div class="mb-4">
              <TextField  v-model="appartment" :label="_('Directives (ex: #3, en arrière, etc...)')"></TextField>
          </div>
    
          <div class="w-full">
              <div v-if="valid" @click="validating=true" class="block my-2 bg-indigo-600 rounded-lg px-4 py-2 uppercase font-medium text-sm text-white text-center mr-2">
                  {{ _("Verify Address") }}
              </div>

              <div v-else class="block my-2 bg-indigo-300 rounded-lg px-4 py-2 uppercase font-medium text-sm text-white text-center mr-2">
                  {{ _("Verify Address") }}
              </div>
    
    
              <div v-if="!standalone" @click="$emit('close')" class="bg-gray-300 rounded-lg px-4 py-2 uppercase font-medium text-sm text-gray-900 text-center">
                  {{ _("Cancel") }}
              </div>
          </div>


          <div class="my-2 text-center">{{ _("OR") }}</div>

          <div class="mb-2">{{ _("Select from one of the suggested addresses") }}</div>


          <div class="mt-4">
              <ul class="divide-y divide-gray-200 mb-4">
                  <li v-for="address in customer.addresses" :key="address.id" @click="useAddress(address.id)" class="bg-white">
                      <div class="px-4 py-4">
                          <IconLocationMarkerSolid class="mr-2" size="4"></IconLocationMarkerSolid> {{ address.address }}
                          <div>
                              <span v-if="address.free_until" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">{{ _("Monthly pass") }}</span>
                          </div>
                      </div>
                  </li>
              </ul>
          </div>

      </template>
      

      
      
  </div>
</template>

<script>
import {lang} from "../lang";

import Vue from "vue";
import IconLocationMarkerSolid from "../../icons/solid/IconLocationMarkerSolid";
import TextField from "./TextField";
import IconXCircleSolid from "../../icons/solid/IconXCircleSolid";

export default {
  name: "AddressChange",
    props: ["value", "app_locale", "standalone", "restaurant", "subtotal"],
    data() {
        return {
            customer: this.value,
            validating: false,
            address: '',
            appartment: '',
            lat: 0,
            lng: 0,
            error: '',
            place_id: '',
            address_is_street: false,
        }
    },
    components: {
        IconXCircleSolid,
        TextField,
        IconLocationMarkerSolid,
    },
    computed: {
        valid() {
            return this.address && (this.address_is_street || this.appartment !== '');
        }
    },
  methods: {


        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
        
        getAddressData(addressData) {

            if (!addressData) {
                return;
            }
            let address = addressData.formatted_address;
            
            let components = {};
            if (addressData.address_components) {
                addressData.address_components.forEach(entry => {
                    entry.types.forEach(type => {
                        components[type] = entry.long_name;
                    })
                })
            }
            
          
          // administrative_area_level_1: "Québec"
          // administrative_area_level_3: "Laval"
          // country: "Canada"
          // locality: "Laval"
          // neighborhood: "Champfleury"
          // political: "Canada"
          // postal_code: "H7L 4W6"
          // route: "Boulevard des Oiseaux"
          // street_number: "2410"


          if (components.street_number && components.route && components.locality && components.administrative_area_level_1 && components.country) {
                address = `${components.street_number} ${components.route}, ${components.locality}, ${components.administrative_area_level_1}, ${components.country}`;
            }
            
          if (!addressData.geometry || !addressData.geometry.location) {
              this.error = this._("We couldn't recognize the address, please enter address carefully.");
              this.address = '';
              this.lat = 0;
              this.lng = 0;
              return;
          }
          
          
          
            this.address_is_street = addressData.types.filter(a => a === 'street_address' || a === 'premise').length > 0;

            this.place_id = addressData.place_id;
            this.address = address;
            this.lat = addressData.geometry.location.lat();
            this.lng = addressData.geometry.location.lng();
           

            console.log(address, addressData, this.address_is_street);
            
        },


        useAddress(id) {
            this.validateAddress({id: id}, () => {
                window.axios.post(this.$route("user.set-address", {customer: this.customer.id}), {
                    id: id
                }).then(response => {
                    if (response.data.error) {
                        this.error = response.data.error;
                        return;
                    }
                    this.customer = response.data.customer;
                    this.$emit('input', this.customer);
                    this.$emit('refresh');
                    Vue.nextTick(() => {
                        this.$emit('close');
                    })
                })
            });
        },
        
        validateAddress(data, callback) {
            if (this.restaurant) {
                window.axios.post(this.$route("user.validate-address", {customer: this.customer.id, restaurant: this.restaurant.id, app_locale: this.app_locale, subtotal: this.subtotal, address: this.address}), data).then(response => {

                    if (response.data.success === -1) {
                        this.error = response.data.message;
                        window.scrollTo(0, 0);
                        return;
                    }
                    
                    if (response.data.success === 0) {
                        this.$emit('alert', response.data.message);
                    }
                    
                    callback();
                    
                })
            } else {
               callback();
            }
        },

        newAddress() {
            this.validateAddress({
                lat: this.lat,
                lng: this.lng,
            }, () => {
                
                window.axios.post(this.$route("user.set-address", {customer: this.customer.id}), {
                    address: this.address,
                    appartment: this.appartment,
                    place_id: this.place_id,
                    lat: this.lat,
                    lng: this.lng,
                }).then(response => {
    
                    if (response.data.error) {
                        this.error = response.data.error;
                        window.scrollTo(0, 0);
                        return;
                    }
                    this.customer = response.data.customer;
                    this.$emit('input', this.customer);
                    Vue.nextTick(() => {
                        this.$emit('close');
                    })
                })

            });
        }
    }
}
</script>

<style scoped>

</style>
